import React, { useState, useEffect } from "react";
import "./Holidays.css";
import apiClient from "../utils/apiClient";
import SessionHandler from "../components/SessionHandler";

/* ✅ Date formatter → DD/MM/YYYY */
const formatDate = (dateStr) => {
  if (!dateStr) return "";

  // YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [y, m, d] = dateStr.split("-");
    return `${d}-${m}-${y}`;
  }

  // DD-MM-YYYY
  if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    return dateStr.replaceAll("-", "/");
  }

  return dateStr;
};

const Overview = () => {
  const [holidays, setHolidays] = useState([]);
  const [upcomingHolidayId, setUpcomingHolidayId] = useState(null);

  useEffect(() => {
    fetchHolidays();
  }, []);

  const fetchHolidays = async () => {
    try {
      const data = await apiClient("/holiday/");
      if (!data) return;

      const list = Array.isArray(data)
        ? data
        : Array.isArray(data.results)
        ? data.results
        : [];

      setHolidays(list);
      setUpcomingHolidayId(getUpcomingHolidayId(list));
    } catch (err) {
      console.error("Error fetching holidays:", err.message);
    }
  };

  const getUpcomingHolidayId = (holidays) => {
    const today = new Date();

    for (const holiday of holidays) {
      const holidayDate = new Date(holiday.date);
      if (!isNaN(holidayDate) && holidayDate >= today) {
        return holiday.id;
      }
    }
    return null;
  };

  return (
    <div className="holiday1-container">
      <div className="holiday1-table-wrapper">
        <table className="holiday1-table">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Name of Holiday</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {holidays.length > 0 ? (
              holidays.map((holiday, index) => (
                <tr
                  key={holiday.id || index}
                  className={
                    holiday.id === upcomingHolidayId
                      ? "highlight-upcoming"
                      : ""
                  }
                >
                  <td>{index + 1}</td>
                  <td>{holiday.name}</td>
                  <td>{formatDate(holiday.date)}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" style={{ textAlign: "center" }}>
                  No holidays found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <SessionHandler />
    </div>
  );
};

export default Overview;
